import firstPageTemplate from "../assets/mini-processing-first-page.pdf"
import lastOfMultiTemplate from "../assets/mini-processing-last-of-multi.pdf"

/** 4×6 mini processing receipt overlay coordinates (PDF points, origin bottom-left). */
export const PROCESSING_RECEIPT_PAGE = { width: 288, height: 432 }

export const PROCESSING_RECEIPT_TEMPLATE_URLS = {
    firstPage: firstPageTemplate,
    lastOfMulti: lastOfMultiTemplate,
}

export const PROCESSING_RECEIPT_LAYOUT = {
    masterNumber: { x: 14, yFromTop: 15, size: 17 },
    barcode: { x: 138, yFromTop: 5, width: 130, height: 25 },
    shipToRegion: { x: 242, yFromTop: 36, size: 7 },
    address: {
        leftX: 10,
        rightX: 152,
        startYFromTop: 55,
        lineHeight: 9.5,
        size: 7,
        nameSize: 7.5,
        maxWidthSingle: 270,
        maxWidthColumn: 132,
    },
    items: {
        startYFromTop: 130,
        rowHeight: 30,
        rowBaselineOffset: 11,
        /** Original template anchors — minimum column widths are derived from these. */
        originalSpeciesX: 16,
        originalProcessX: 65,
        originalQtyRightX: 168,
        /** Gap between species → process and process → qty (pt). */
        columnGap: 6,
        /** Max right edge for line-item content (pt inset from page edge). */
        rightMargin: 13,
        size: 9,
    },
    footer: {
        pageX: 46,
        boxesX: 148,
        depotX: 278,
        yFromTop: 417,
        size: 9,
    },
}

export function processingReceiptYFromTop(yFromTop) {
    return PROCESSING_RECEIPT_PAGE.height - yFromTop
}

export function processingReceiptBaselineFromTop(yFromTop, fontSize) {
    return processingReceiptYFromTop(yFromTop + fontSize * 0.72)
}

export const PROCESSING_RECEIPT_ITEMS_PER_PAGE = 7
